import { formInitPromo } from '../../../views/Promo/formInit'
import _ from 'lodash'

export default {
  isLoading: false,
  promos: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  promo: {
    isLoading: false,
    data: _.cloneDeep(formInitPromo),
    status: null,
    error: false,
    errorMessage: null
  },
  status: null
};
